<template>
	<div>
		<v-toolbar flat color="white">
			<v-toolbar-title>{{ $t('users.title') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-select
					light lazy multiple clearable dense v-model="groupsFilter" class="select-filter"
					:items="groups" item-text="name" item-value="_id" :label="$t('users.filter.filter-groups')">
				<template v-slot:selection="{ item, index }">
					<v-chip v-if="index === 0">
						<span>{{ item.name }}</span>
					</v-chip>
					<span
							v-if="index === 1"
							class="grey--text caption"
					>({{ `+${groupsFilter.length - 1} ${$t('users.filter.others').toLowerCase()}` }})</span>
				</template>
			</v-select>
		</v-toolbar>
		<v-data-table
				:headers="headers"
				:items="filteredUsers"
				:single-expand="false"
				:expanded.sync="expanded"
				item-key="_id"
				show-expand
				class="elevation-2">
			<template v-slot:expanded-item="{ item }">
				<td :colspan="headers.length">
					<users-table-item :user="item"
                            @removeUser="remove"
                            @updateUser="updateUser"></users-table-item>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UsersTableItem from './users-table-item';

export default {
	name: 'UserListItem',
	components: { UsersTableItem },
	props: {
		users: {
			type: Array,
		}
	},
	data() {
		return {
			expanded: [],
			userDetails: [],
			groupsFilter: [],
			hover: false,
			showConfirmDeleteDialog: false,
		};
	},
	computed: {
		...mapState({
			groups: state => state.group.groups,
		}),
		headers() {
			return [
				{
					text: this.$t('users.table.first-name'),
					align: 'left',
					sortable: true,
					value: 'firstName'
				},
				{
					text: this.$t('users.table.last-name'),
					align: 'left',
					sortable: true,
					value: 'lastName'
				},
				{
					text: this.$t('users.table.email'),
					align: 'left',
					sortable: true,
					value: 'email'
				},
				{
					text: this.$t('users.table.group'),
					align: 'left',
					sortable: true,
					value: 'group.name'
				},
				{ text: '', value: 'data-table-expand' },
			];
		},
		filteredUsers() {
			if (this.groupsFilter.length > 0) {
				return this.userDetails.filter(user => this.groupsFilter.some(groupId => user.group._id === groupId));
			}
			return this.userDetails;
		},
	},
	watch: {
		users(users) {
			this.userDetails = JSON.parse(JSON.stringify(users));
		}
	},
	methods: {
		...mapActions({
			updateUser: 'user/updateUser',
			remove: 'user/delete'
		})
	}
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

::v-deep .v-data-table-header {
	background-color: $light-grey;
}

.select-filter {
	max-width: 250px;
}
</style>
